import { Sprite, Texture, Container, mesh } from 'pixi.js'
import { FT, Tween } from 'ft'

const { NineSlicePlane } = mesh
const $bar = 'scroll-bar'
const $barBG = 'scroll-bar-bg'

const { rm } = FT
rm.addImage($bar)
rm.addImage($barBG)

export default class ScrollBar extends Container {
  direction = 'vertical'
  maxOverstep = 100
  bg = null
  bar = null

  constructor() {
    super()
    const { rm } = FT
    this.bg = new NineSlicePlane(rm.texture($barBG), 3, 3, 6, 6)
    this.bar = new NineSlicePlane(rm.texture($bar), 3, 3, 6, 6)
    this.addChild(this.bg, this.bar)
    this.on('removed', this.onDestory, this)
  }

  onDestory() {
    if (this.action) this.action.stop()
  }

  updateParams({ visibleLen, len, setter, getter }) {
    this.scrollable = visibleLen < len

    this.visibleLen = visibleLen
    this.len = len
    this.maxOffset = this.maxOverstep
    this.minOffset = this.visibleLen - this.len - this.maxOverstep
    this.setter = v => {
      setter(v)
      this.updateBar()
    }
    this.getter = getter
    Object.defineProperty(this, 'offset', {
      enumerable: true,
      configurable: true,
      set: this.setter,
      get: this.getter,
    })
    this.updateView()
  }

  // TODO where to update view ?
  updateView() {
    const { visibleLen, len } = this
    if (this.direction !== 'vertical') {
      this.rotation = Math.PI * -0.5
    }
    this.bg.height = visibleLen
    this.bar.height = (visibleLen / len) * visibleLen

    if (!this.mask) {
      const m = new Sprite(Texture.WHITE)
      this.mask = m
      this.addChild(m)
    }
    this.visible = this.scrollable
    this.mask.width = this.bg.width
    this.mask.height = this.bg.height
    this.relativeOffset = -this.len / this.visibleLen
    this.offset = Math.min(0, Math.max(this.minOffset, this.offset))
    this.bar.y = Math.max(
      0,
      Math.min(this.minOffset / this.relativeOffset, this.bar.y)
    )
  }

  updateBar() {
    if (!this.scrollable) return
    this.bar.y = this.offset / this.relativeOffset
  }

  handleStart(v, time) {
    if (!this.scrollable) return
    if (this.action) this.action.stop()

    this.orignOffset = this.offset
    this.start = v
    this.last = v
    this.lastTime = time
  }

  handleMove(v, time) {
    if (!this.scrollable) return

    this.velocity = (v - this.last) / (time - this.lastTime)
    this.lastTime = time
    this.last = v

    const offset = (this.offset = this.orignOffset + v - this.start)
    this.offset = offset
    if (offset > this.maxOffset) {
      this.offset = this.maxOffset
    } else if (offset < this.minOffset) {
      this.offset = this.minOffset
    }
  }

  handleEnd() {
    if (!this.scrollable) return
    this.orignOffset = 0
    this.start = 0
    this.last = 0
    this.lastTime = 0

    this.handleOverstep()
    this.handleMomentum()
  }

  // 弹性
  handleOverstep() {
    const ov = this.overstep
    if (ov !== 0) {
      this.autoScroll(ov > 0 ? 0 : this.visibleLen - this.len)
    }
  }

  // 冲力
  handleMomentum() {
    if (Math.abs(this.velocity) < 0.3) return

    const v = this.velocity
    this.velocity = 0
    let offset = this.offset

    const action = new Tween({ velocity: v * 10 })
      .to({ velocity: 0 }, 200 * Math.abs(v))
      .onUpdate(v => {
        offset += v.velocity
        if (offset < this.maxOffset && offset > this.minOffset) {
          this.setter(offset)
        } else {
          action.stop()
          this.handleOverstep()
        }
      })
      .onComplete(() => this.handleOverstep())
      .start()

    this.action = action
  }

  autoScroll(to) {
    this.action = new Tween({ offset: this.offset })
      .to({ offset: to }, 500)
      .onUpdate(v => {
        this.setter(v.offset)
      })
      .start()
  }

  scrollTo(percent, isAuto) {
    const { visibleLen, len } = this
    const offset = -1 * (len - visibleLen) * percent
    if (isAuto) {
      this.autoScroll(offset)
    } else {
      this.setter(offset)
    }
  }

  reset() {
    if (this.action) this.action.stop()
    this.setter(0)
  }

  get overstep() {
    const { offset, len, visibleLen } = this
    if (offset > 0) return offset
    if (offset < visibleLen - len) {
      return offset - (visibleLen - len)
    }
    return 0
  }
}
